import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Quais KPIs do Dashboard estão visíveis. Persiste em localStorage.
 * Padrão: todos visíveis.
 */

export type KpiKey =
  | 'running'
  | 'ready'
  | 'off'
  | 'blocked'
  | 'unblocked'
  | 'gpsFresh'
  | 'gpsStale'
  | 'noComm'
  | 'availability';

interface DashboardState {
  visible: Record<KpiKey, boolean>;
  toggle: (k: KpiKey) => void;
  setAll: (state: boolean) => void;
  reset: () => void;
}

const DEFAULT: Record<KpiKey, boolean> = {
  running: true,
  ready: true,
  off: true,
  blocked: true,
  unblocked: true,
  gpsFresh: true,
  gpsStale: true,
  noComm: true,
  availability: true,
};

export const useDashboardStore = create<DashboardState>()(
  persist(
    (set) => ({
      visible: { ...DEFAULT },
      toggle: (k) =>
        set((s) => ({ visible: { ...s.visible, [k]: !s.visible[k] } })),
      setAll: (state) =>
        set(() => ({
          visible: Object.fromEntries(Object.keys(DEFAULT).map((k) => [k, state])) as Record<
            KpiKey,
            boolean
          >,
        })),
      reset: () => set({ visible: { ...DEFAULT } }),
    }),
    {
      name: 'fismatek-dashboard-kpis',
      migrate: (persisted) => {
        // Garante que chaves novas (futuras) caem como true por padrão
        const v = (persisted as DashboardState | null)?.visible ?? {};
        return {
          ...(persisted as DashboardState),
          visible: { ...DEFAULT, ...v },
        };
      },
    },
  ),
);
